<template>
  <h2 class="c-games_gameListHeader_heading">
    <span class="c-games_gameListHeader_title">すべてのゲーム</span>
    <span class="c-games_gameListHeader_gameCount" v-if="!loading">{{ appCount }}タイトル</span>
  </h2>
</template>

<script>
export default {
  props: {
    appCount: Number,
    loading: Boolean
  }
}
</script>

<style lang="scss">
//styled by external css.
</style>
